import React from 'react';
import {
  SiOpenai, SiAnthropic, SiGooglegemini, SiMeta, SiMistralai, SiHuggingface,
  SiPerplexity, SiOllama,
  SiLangchain, SiLanggraph, SiLangflow, SiCrewai, SiHaystack, SiN8N, SiMake,
  SiZapier, SiRetool,
  SiWhatsapp, SiTelegram, SiSlack, SiDiscord, SiTwilio, SiMessenger, SiViber,
  SiWechat, SiIntercom, SiZendesk,
  SiSalesforce, SiHubspot, SiZoho, SiNotion, SiAirtable, SiCalendly, SiJira,
  SiConfluence,
  SiPostgresql, SiMongodb, SiMysql, SiMariadb, SiRedis, SiElasticsearch,
  SiSupabase, SiSnowflake, SiClickhouse, SiNeo4J, SiMilvus,
  SiGooglecloud, SiDocker, SiKubernetes, SiCloudflare, SiFirebase, SiVercel,
  SiNetlify, SiDigitalocean, SiHeroku, SiRender, SiRailway,
  SiGooglesheets, SiGoogledrive, SiDropbox, SiGmail, SiSendgrid, SiMailchimp,
  SiShopify, SiWoocommerce, SiWordpress, SiWebflow, SiDatabricks, SiGooglebigquery,
  SiStripe, SiRazorpay, SiPaytm, SiPhonepe, SiPaypal, SiSap, SiQuickbooks,
} from 'react-icons/si';
import './IntegrationsMarquee.css';

// Icon present → real brand logo. Icon null → tinted abbr badge fallback.
const rows = [
  {
    label: 'LLMs',
    items: [
      { name: 'OpenAI',        Icon: SiOpenai,       color: '#10A37F' },
      { name: 'Claude',        Icon: SiAnthropic,    color: '#D97757' },
      { name: 'Gemini',        Icon: SiGooglegemini, color: '#8E75F8' },
      { name: 'Llama 3',       Icon: SiMeta,         color: '#0668E1' },
      { name: 'Mistral',       Icon: SiMistralai,    color: '#FF7000' },
      { name: 'Hugging Face',  Icon: SiHuggingface,  color: '#FFD21E' },
      { name: 'Perplexity',    Icon: SiPerplexity,   color: '#20B8CD' },
      { name: 'Ollama',        Icon: SiOllama,       color: '#FFFFFF' },
      { name: 'Cohere',        Icon: null,           color: '#39594D', abbr: 'CO' },
      { name: 'Groq',          Icon: null,           color: '#F55036', abbr: 'GQ' },
      { name: 'Together AI',   Icon: null,           color: '#7C3AED', abbr: 'TA' },
    ],
  },
  {
    label: 'Orchestration',
    items: [
      { name: 'LangChain',     Icon: SiLangchain,    color: '#1C9C7C' },
      { name: 'LangGraph',     Icon: SiLanggraph,    color: '#1C9C7C' },
      { name: 'LangFlow',      Icon: SiLangflow,     color: '#7C3AED' },
      { name: 'CrewAI',        Icon: SiCrewai,       color: '#FF5A50' },
      { name: 'Haystack',      Icon: SiHaystack,     color: '#03AF9D' },
      { name: 'n8n',           Icon: SiN8N,          color: '#EA4B71' },
      { name: 'Make',          Icon: SiMake,         color: '#6D00CC' },
      { name: 'Zapier',        Icon: SiZapier,       color: '#FF4F00' },
      { name: 'Retool',        Icon: SiRetool,       color: '#3D3D3D' },
      { name: 'AutoGen',       Icon: null,           color: '#0078D4', abbr: 'AG' },
      { name: 'Flowise',       Icon: null,           color: '#3B82F6', abbr: 'FL' },
    ],
  },
  {
    label: 'Messaging',
    items: [
      { name: 'WhatsApp',      Icon: SiWhatsapp,     color: '#25D366' },
      { name: 'Telegram',      Icon: SiTelegram,     color: '#26A5E4' },
      { name: 'Slack',         Icon: SiSlack,        color: '#E01E5A' },
      { name: 'Discord',       Icon: SiDiscord,      color: '#5865F2' },
      { name: 'Twilio',        Icon: SiTwilio,       color: '#F22F46' },
      { name: 'Messenger',     Icon: SiMessenger,    color: '#00B2FF' },
      { name: 'Viber',         Icon: SiViber,        color: '#7360F2' },
      { name: 'WeChat',        Icon: SiWechat,       color: '#07C160' },
      { name: 'Intercom',      Icon: SiIntercom,     color: '#1F8DED' },
      { name: 'Zendesk',       Icon: SiZendesk,      color: '#03363D' },
      { name: 'MS Teams',      Icon: null,           color: '#6264A7', abbr: 'MT' },
    ],
  },
  {
    label: 'CRM & Sales',
    items: [
      { name: 'Salesforce',    Icon: SiSalesforce,   color: '#00A1E0' },
      { name: 'HubSpot',       Icon: SiHubspot,      color: '#FF7A59' },
      { name: 'Zoho',          Icon: SiZoho,         color: '#E42527' },
      { name: 'Notion',        Icon: SiNotion,       color: '#FFFFFF' },
      { name: 'Airtable',      Icon: SiAirtable,     color: '#18BFFF' },
      { name: 'Calendly',      Icon: SiCalendly,     color: '#006BFF' },
      { name: 'Jira',          Icon: SiJira,         color: '#0052CC' },
      { name: 'Confluence',    Icon: SiConfluence,   color: '#172B4D' },
      { name: 'Pipedrive',     Icon: null,           color: '#017737', abbr: 'PD' },
      { name: 'Monday.com',    Icon: null,           color: '#FF3D57', abbr: 'MN' },
    ],
  },
  {
    label: 'Databases',
    items: [
      { name: 'PostgreSQL',    Icon: SiPostgresql,   color: '#4169E1' },
      { name: 'MongoDB',       Icon: SiMongodb,      color: '#47A248' },
      { name: 'MySQL',         Icon: SiMysql,        color: '#4479A1' },
      { name: 'MariaDB',       Icon: SiMariadb,      color: '#C49A6C' },
      { name: 'Redis',         Icon: SiRedis,        color: '#FF4438' },
      { name: 'Elasticsearch', Icon: SiElasticsearch,color: '#005571' },
      { name: 'Supabase',      Icon: SiSupabase,     color: '#3ECF8E' },
      { name: 'Snowflake',     Icon: SiSnowflake,    color: '#29B5E8' },
      { name: 'ClickHouse',    Icon: SiClickhouse,   color: '#FFCC01' },
      { name: 'Neo4j',         Icon: SiNeo4J,        color: '#4581C3' },
      { name: 'Milvus',        Icon: SiMilvus,       color: '#00A1EA' },
      { name: 'Pinecone',      Icon: null,           color: '#FFFFFF', abbr: 'PC' },
      { name: 'Qdrant',        Icon: null,           color: '#DC244C', abbr: 'QD' },
      { name: 'Weaviate',      Icon: null,           color: '#FA0050', abbr: 'WV' },
    ],
  },
  {
    label: 'Cloud',
    items: [
      { name: 'Google Cloud',  Icon: SiGooglecloud,  color: '#4285F4' },
      { name: 'Docker',        Icon: SiDocker,       color: '#2496ED' },
      { name: 'Kubernetes',    Icon: SiKubernetes,   color: '#326CE5' },
      { name: 'Cloudflare',    Icon: SiCloudflare,   color: '#F38020' },
      { name: 'Firebase',      Icon: SiFirebase,     color: '#FFCA28' },
      { name: 'Vercel',        Icon: SiVercel,       color: '#FFFFFF' },
      { name: 'Netlify',       Icon: SiNetlify,      color: '#00C7B7' },
      { name: 'DigitalOcean',  Icon: SiDigitalocean, color: '#0080FF' },
      { name: 'Heroku',        Icon: SiHeroku,       color: '#430098' },
      { name: 'Render',        Icon: SiRender,       color: '#46E3B7' },
      { name: 'Railway',       Icon: SiRailway,      color: '#FFFFFF' },
      { name: 'AWS',           Icon: null,           color: '#FF9900', abbr: 'AW' },
      { name: 'Azure',         Icon: null,           color: '#0078D4', abbr: 'AZ' },
    ],
  },
  {
    label: 'Apps & Data',
    items: [
      { name: 'Google Sheets', Icon: SiGooglesheets, color: '#34A853' },
      { name: 'Google Drive',  Icon: SiGoogledrive,  color: '#4285F4' },
      { name: 'Dropbox',       Icon: SiDropbox,      color: '#0061FF' },
      { name: 'Gmail',         Icon: SiGmail,        color: '#EA4335' },
      { name: 'SendGrid',      Icon: SiSendgrid,     color: '#51A9E3' },
      { name: 'Mailchimp',     Icon: SiMailchimp,    color: '#FFE01B' },
      { name: 'Shopify',       Icon: SiShopify,      color: '#7AB55C' },
      { name: 'WooCommerce',   Icon: SiWoocommerce,  color: '#96588A' },
      { name: 'WordPress',     Icon: SiWordpress,    color: '#21759B' },
      { name: 'Webflow',       Icon: SiWebflow,      color: '#146EF5' },
      { name: 'Databricks',    Icon: SiDatabricks,   color: '#FF3621' },
      { name: 'BigQuery',      Icon: SiGooglebigquery, color: '#669DF6' },
    ],
  },
  {
    label: 'Payments',
    items: [
      { name: 'Stripe',        Icon: SiStripe,       color: '#635BFF' },
      { name: 'Razorpay',      Icon: SiRazorpay,     color: '#0C2451' },
      { name: 'Paytm',         Icon: SiPaytm,        color: '#00BAF2' },
      { name: 'PhonePe',       Icon: SiPhonepe,      color: '#5F259F' },
      { name: 'PayPal',        Icon: SiPaypal,       color: '#003087' },
      { name: 'SAP',           Icon: SiSap,          color: '#0FAAFF' },
      { name: 'QuickBooks',    Icon: SiQuickbooks,   color: '#2CA01C' },
      { name: 'PayU',          Icon: null,           color: '#A3D900', abbr: 'PU' },
      { name: 'Cashfree',      Icon: null,           color: '#1A73E8', abbr: 'CF' },
      { name: 'Oracle ERP',    Icon: null,           color: '#F80000', abbr: 'OR' },
    ],
  },
  {
    label: 'Identity',
    items: [
      { name: 'HL7 / FHIR',    Icon: null,           color: '#3B82F6', abbr: 'HL' },
      { name: 'Aadhaar eSign', Icon: null,           color: '#F77F00', abbr: 'AA' },
      { name: 'DigiLocker',    Icon: null,           color: '#1E63B0', abbr: 'DL' },
      { name: 'PAN Verify',    Icon: null,           color: '#00897B', abbr: 'PN' },
      { name: 'GSTN APIs',     Icon: null,           color: '#FF6B35', abbr: 'GS' },
      { name: 'KYC APIs',      Icon: null,           color: '#2DD4BF', abbr: 'KY' },
      { name: 'Surepass',      Icon: null,           color: '#0056B3', abbr: 'SU' },
      { name: 'IDfy',          Icon: null,           color: '#6C63FF', abbr: 'ID' },
      { name: 'Epic EHR',      Icon: null,           color: '#C8102E', abbr: 'EP' },
      { name: 'Practo',        Icon: null,           color: '#2C97DE', abbr: 'PR' },
    ],
  },
];

const Chip = ({ item, hidden }) => (
  <div className="im-chip" aria-hidden={hidden}>
    {item.Icon ? (
      <span className="im-chip-logo" style={{ color: item.color }}>
        <item.Icon size={16} />
      </span>
    ) : (
      <span className="im-chip-abbr" style={{ '--brand': item.color }}>
        {item.abbr}
      </span>
    )}
    <span className="im-chip-name">{item.name}</span>
  </div>
);

const MarqueeRow = ({ items, reverse, label }) => {
  const doubled = [...items, ...items];
  return (
    <div className="im-row">
      <span className="im-row-label" aria-hidden="true">{label}</span>
      <div className="im-track-wrap">
        <div className={`im-track${reverse ? ' reverse' : ''}`} aria-label={`${label} integrations`}>
          {doubled.map((item, i) => (
            <Chip key={`${item.name}-${i}`} item={item} hidden={i >= items.length} />
          ))}
        </div>
      </div>
    </div>
  );
};

export const IntegrationsMarquee = () => (
  <section className="im-section">
    <div className="im-header">
      <h2 className="im-title">Connects to your entire stack.</h2>
      <p className="im-sub">
        LLMs, orchestration frameworks, messaging platforms, CRMs, databases,
        cloud infra, payments, and compliance APIs — we integrate with the tools
        you already run.
      </p>
    </div>
    <div className="im-rows">
      {rows.map((row, i) => (
        <MarqueeRow key={row.label} label={row.label} items={row.items} reverse={i % 2 !== 0} />
      ))}
    </div>
  </section>
);
